export const DEFAULT_COLORS = [
  "#EF4444",
  "#F38744",
  "#EAAA08",
  "#3ABA65",
  "#33C9B7",
  "#0BA5EC",
  "#9260FB",
  "#D360FB",
  "#5F758F",
];

export function getContrastColor(hex: string): "black" | "white" {
  const c = hex.replace("#", "");

  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5 ? "black" : "white";
}
